<template>
  <div>
    <Snackbar :SnackBarComponent="SnackBarComponent" />
    <v-dialog persistent max-width="400px" v-model="dialogSavePDFWarning">
      <v-card>
        <v-toolbar dark color="primary" dense class="elevation-0">
          <div>Save Template</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogSavePDFWarningEmit((Toggle = 1))"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text class="pb-0 mt-4">
          <v-form ref="form">
            <v-text-field
              dense
              outlined
              class="FontSize"
              :readonly="
                TemplateStoreObj != undefined &&
                TemplateStoreObj.action == 'EDIT'
              "
              label="Template Name"
              v-model="template_name"
              :rules="[(v) => !!v || 'Required']"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions class="py-0 pb-4">
          <v-spacer></v-spacer>
          <v-btn
            small
            class="borderRadius fontStyle text-capitalize"
            color="secondary"
            outlined
            @click="dialogSavePDFWarningEmit((Toggle = 1))"
            ><v-icon small class="mr-1">mdi-close</v-icon>Cancel</v-btn
          >
          <v-btn
            small
            class="borderRadius fontStyle text-capitalize"
            :loading="loading"
            color="secondary"
            @click="validateMethod()"
            ><v-icon small class="mr-1">mdi-check</v-icon>Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Snackbar from "@/components/Extras/Snackbar.vue";
import { API, graphqlOperation } from "aws-amplify";
import { createPDFTemplate, updatePDFTemplate } from "@/graphql/mutations.js";
export default {
  props: {
    StoreObj: Object,
    TemplateStoreObj: Object,
    dialogSavePDFWarning: Boolean,
    pageItems: Array,
  },
  components: {
    Snackbar,
  },
  data: () => ({
    Toggle: 0,
    loading: false,
    template_name: "",
    SnackBarComponent: {},
  }),
  watch: {
    dialogSavePDFWarning(val) {
      if (val == true) {
        console.warn("TemplateStoreObj", this.TemplateStoreObj);
        if (this.TemplateStoreObj.action == "EDIT") {
          this.template_name = this.TemplateStoreObj.template_name;
        }
      }
    },
  },
  methods: {
    validateMethod() {
      if (this.$refs.form.validate()) {
        if (
          this.TemplateStoreObj.action == "CREATE" ||
          this.TemplateStoreObj.action == "COPY"
        ) {
          this.createPDFTemplatesMethod();
        } else {
          this.updateTemplatesMethod();
        }
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: "Please Enter Template Name",
        };
      }
    },
    async createPDFTemplatesMethod() {
      try {
        console.warn("templateItems", this.templateItems);
        let TempHtml = [];
        for (let i = 0; i < this.pageItems.length; i++) {
          TempHtml.push(this.pageItems[i].template_html);
          this.pageItems[i].currNodes = [];
          this.pageItems[i].nextNodes = [];
        }
        var inputParams = {
          user_id: this.$store.getters.get_current_user_details.user_id,
          template_name: this.template_name,
          settings: JSON.stringify(this.pageItems),
          template_html: JSON.stringify(TempHtml),
        };
        this.loading = true;
        let result = await API.graphql(
          graphqlOperation(createPDFTemplate, {
            input: inputParams,
          })
        );
        var ResultObject = JSON.parse(result.data.CreatePDFTemplate);
        if (ResultObject.status == "Success") {
          this.dialogSavePDFWarningEmit((this.Toggle = 2), ResultObject);
        }
        this.loading = false;
      } catch (error) {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: error.errors[0].message,
        };
        this.loading = false;
      }
    },
    async updateTemplatesMethod() {
      try {
        let TempHtml = [];
        for (let i = 0; i < this.pageItems.length; i++) {
          TempHtml.push(this.pageItems[i].template_html);
          this.pageItems[i].currNodes = [];
          this.pageItems[i].nextNodes = [];
        }
        var inputParams = {
          user_id: this.$store.getters.get_current_user_details.user_id,
          template_id: this.TemplateStoreObj.template_id,
          template_name: this.template_name,
          settings: JSON.stringify(this.pageItems),
          template_html: JSON.stringify(TempHtml),
        };
        this.loading = true;
        let result = await API.graphql(
          graphqlOperation(updatePDFTemplate, {
            input: inputParams,
          })
        );
        var ResultObject = JSON.parse(result.data.UpdatePDFTemplate);
        if (ResultObject.status == "Success") {
          this.dialogSavePDFWarningEmit((this.Toggle = 2), ResultObject);
        }
        this.loading = false;
      } catch (error) {
        console.log("error", error);
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: error.errors[0].message,
        };
        this.loading = false;
      }
    },
    dialogSavePDFWarningEmit(Toggle, ResultObject) {
      if (this.$refs.form != undefined) {
        this.$refs.form.reset();
      }
      this.$emit("clicked", Toggle, ResultObject);
    },
  },
};
</script>
